enum TypeOfPayment {
    GoCardless, Manual, Stripe
}

export {TypeOfPayment};